import { IconButton, styled } from '@mui/material';

const AppBarIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(7),
  '& img': {
    width: '25px',
    height: '25px',
  },
}));

export default AppBarIconButton;
